var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"actionbar menu_wkBox_back_box",class:_vm.className},[_c('div',{staticClass:"action-list"},[_c('ul',{staticClass:"action-others"},[_vm._t("icons")],2),_vm._t("buttons")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }